module.exports = __webpack_public_path__ + "static/media/feb112019.dc13cdb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feb112019.png
// module id = 252
// module chunks = 0